import { DEFAULT_ZOOM_FACTOR } from './constants';
import React, { createContext, useContext, useState } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

type A11yMode = string | null;

export type Context = {
  a11yMode?: A11yMode,
  setA11yMode?: Dispatch<SetStateAction<A11yMode>>,
  isHighContrast?: boolean,
  setIsHighContrast?: Dispatch<SetStateAction<boolean>>,
  zoomFactor?: number | null,
  setZoomFactor?: Dispatch<SetStateAction<number>>,
  resetAccessibilityPreferences?: () => void,
};

type InitialValues = {
  a11yMode?: A11yMode,
  isHighContrast?: boolean,
  zoomFactor?: number,
};

export const AccessibilityContext = createContext<Context>({});

export const AccessibilityProvider = ({
  children,
  initialValues,
}: {
  children: ReactNode,
  initialValues?: InitialValues,
}) => {
  const [a11yMode, setA11yMode] = useState<A11yMode>(initialValues?.a11yMode || null);
  const [isHighContrast, setIsHighContrast] = useState<boolean>(initialValues?.isHighContrast || false);
  const [zoomFactor, setZoomFactor] = useState<number>(initialValues?.zoomFactor || DEFAULT_ZOOM_FACTOR);

  return (
    <AccessibilityContext.Provider
      value={{
        a11yMode,
        setA11yMode,
        isHighContrast,
        setIsHighContrast,
        zoomFactor,
        setZoomFactor,
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibilityContext = () => useContext(AccessibilityContext);
